import axios from "axios";
import httpBase from "./httpBase";
import _ from "lodash";
import AuthManager from "../../utils/AuthManager";

function createInstance() {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_API_URL,
  // baseURL: "https://staging.etiqa.com.sg/MyEtiqa119/",
    timeout: 50000,
    headers: {
      "Content-Type": "application/json",
    },
  });

  instance.interceptors.request.use(
    (config) => config,
    (error) => {
      if (
        error.code === "ECONNABORTED" ||
        _.get(error, "response.status", 0) === 408
      ) {
        console.log("httpManager networkTimeOutError");
      } else {
        return Promise.reject(error);
      }
    }
  );

  return instance;
}

function createInstanceToken() {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_API_URL,
    //baseURL: "https://staging.etiqa.com.sg/MyEtiqa119/",

    timeout: 50000,
    headers: {
      "Content-Type": "application/json",
    },
  });

  instance.interceptors.request.use((config) => {
    return AuthManager.retrieveToken().then((value) => {
      config.headers.Authorization = `Bearer ${value}`;
      return config;
    });
  });

  instance.interceptors.request.use(
    (config) => config,
    (error) => {
      if (
        error.code === "ECONNABORTED" ||
        _.get(error, "response.status", 0) === 408
      ) {
        console.log("httpManager networkTimeOutError");
      } else {
        return Promise.reject(error);
      }
    }
  );

  return instance;
}


function createInstanceSessionToken() {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_BASE_API_URL,
    //baseURL: "https://staging.etiqa.com.sg/MyEtiqa119/",

    timeout: 50000,
    headers: {
      "Content-Type": "application/json",
    },
  });

  instance.interceptors.request.use((config) => {
    return AuthManager.retrieveTokenSession().then((value) => {
      config.headers.Authorization = `Bearer ${value}`;
      return config;
    });
  });

  instance.interceptors.request.use(
    (config) => config,
    (error) => {
      if (
        error.code === "ECONNABORTED" ||
        _.get(error, "response.status", 0) === 408
      ) {
        console.log("httpManager networkTimeOutError");
      } else {
        return Promise.reject(error);
      }
    }
  );

  return instance;
}

const apiInstance = createInstance();
const apiInstanceToken = createInstanceToken();
const apiSessionToken = createInstanceSessionToken()
export  {apiInstance,apiInstanceToken,apiSessionToken};
